// biome-ignore-all lint/security/noDangerouslySetInnerHtml: the confirmation text is admin-authored (Help Content) and always rendered through sanitizeRichText (via richTextDisplayHtml).
// =============================================================================
// VerifyAddressModal.jsx — responder confirmation before verifying a delivery address
// =============================================================================
// Shown when a responder clicks "Verify address" on the request (StaffTopInfoStrip).
// The body text is EDITABLE via Manage → System Content → Help Content → Responder
// (key `responder_verify_address`); a hardcoded default is used if that row is
// empty, so the gate never shows blank. Two actions: Cancel, and "I have done
// this - Verify" (calls onConfirm, which flips zephyr_verified on the address).
// =============================================================================

import React from "react";
import { getHelpText } from "../../data/helpContent";
import { richTextDisplayHtml } from "../../services/richText";
import { ModalBackdrop } from "../form/FormUI.jsx";

export const VERIFY_ADDRESS_HELP_KEY = "responder_verify_address";
export const VERIFY_ADDRESS_DEFAULT_TEXT =
  "Before Verifying this address make sure you have either used the comment " +
  "utility or ideally phoned the caseworker and confirmed that this is NOT " +
  "their client's address.";

export function VerifyAddressModal({ onConfirm, onCancel }) {
  const [text, setText] = React.useState(null);
  const [busy, setBusy] = React.useState(false);

  React.useEffect(function () {
    let alive = true;
    getHelpText(VERIFY_ADDRESS_HELP_KEY).then(function (content) {
      if (!alive) return;
      setText(content?.trim() ? content : VERIFY_ADDRESS_DEFAULT_TEXT);
    });
    return function () {
      alive = false;
    };
  }, []);

  const body = text ?? VERIFY_ADDRESS_DEFAULT_TEXT;

  return (
    <ModalBackdrop
      portal
      onClose={onCancel}
      contentStyle={{
        background: "white",
        borderRadius: 12,
        padding: 28,
        width: "calc(100vw - 40px)",
        maxWidth: 520,
        boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
        maxHeight: "80vh",
        overflowY: "auto",
        overflowX: "hidden",
        boxSizing: "border-box",
        textAlign: "left",
      }}
    >
      <strong style={{ color: "#00695C", fontSize: 16, display: "block", marginBottom: 14 }}>
        Verify delivery address
      </strong>
      <div
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          color: "#333",
          fontSize: 14,
          lineHeight: 1.7,
          margin: "0 0 20px",
          maxWidth: "100%",
          textAlign: "left",
        }}
        dangerouslySetInnerHTML={{ __html: richTextDisplayHtml(body) }}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
        <button
          type="button"
          onClick={onCancel}
          disabled={busy}
          style={{
            background: "white",
            color: "#37474F",
            border: "1px solid #B0BEC5",
            borderRadius: 6,
            padding: "8px 16px",
            fontSize: 13,
            fontWeight: 600,
            cursor: busy ? "default" : "pointer",
            fontFamily: "inherit",
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={async function () {
            setBusy(true);
            try {
              await onConfirm();
            } finally {
              setBusy(false);
            }
          }}
          style={{
            background: "#F57C00",
            color: "white",
            border: "none",
            borderRadius: 6,
            padding: "8px 16px",
            fontSize: 13,
            fontWeight: 700,
            cursor: busy ? "default" : "pointer",
            fontFamily: "inherit",
            opacity: busy ? 0.7 : 1,
          }}
        >
          {busy ? "Verifying…" : "I have done this - Verify"}
        </button>
      </div>
    </ModalBackdrop>
  );
}
